import { isInternalTech, isUserManagedBySupplier } from './AuthUtils';
import { FILTER_CONFIG_NAMES } from './DataConstants';

export const getInvoiceFilterConfig = ({ filters, userType, currentUser }) => {
	const isBuyer = userType !== 'supplier' || isInternalTech(currentUser);
	return [
		filters[FILTER_CONFIG_NAMES.LOCATION],
		filters[FILTER_CONFIG_NAMES.AREA],
		filters[FILTER_CONFIG_NAMES.ASSET],
		filters[FILTER_CONFIG_NAMES.PROBLEM_TYPE],
		filters[FILTER_CONFIG_NAMES.PRIORITY],
		...(isBuyer && !isUserManagedBySupplier(currentUser)
			? [filters[FILTER_CONFIG_NAMES.SUPPLIER]]
			: []),
		...(!isBuyer ? [filters[FILTER_CONFIG_NAMES.TRADE]] : []),
		...(isBuyer ? [filters[FILTER_CONFIG_NAMES.BRAND]] : []),
		...(isBuyer ? [filters[FILTER_CONFIG_NAMES.HAS_GL_CODE]] : []),
		...(isBuyer ? [filters[FILTER_CONFIG_NAMES.HAS_PO_NUMBER]] : []),
		...(isBuyer ? [filters[FILTER_CONFIG_NAMES.IS_CAPEX]] : []),
		...(isBuyer ? [filters[FILTER_CONFIG_NAMES.IS_PLANNED_MAINTENANCE]] : []),
		filters[FILTER_CONFIG_NAMES.PUBLISHED_AT],
		filters[FILTER_CONFIG_NAMES.APPROVED_AT],
		filters[FILTER_CONFIG_NAMES.MARKED_PAID_AT],
		filters[FILTER_CONFIG_NAMES.CREATED_AT],
		filters[FILTER_CONFIG_NAMES.COMPLETED_AT],
	].filter(Boolean);
};
